import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from 'react-query'

import { AuthProvider } from './contexts/authContext'
import { SocketProvider } from './contexts/socketContext'

import Main from './main'
import ProtectedRoute from './components/protectedRoute'
import Login from './pages/login'


export default function App() {
  const queryClient = new QueryClient()
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <div className="app">
            <Switch>
              <Route path="/login" children={<Login />} />
              <ProtectedRoute path="/">
                <SocketProvider>
                  <Main />
                </SocketProvider>
              </ProtectedRoute>
            </Switch>
          </div>
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
}